<div class="modal-md confirm-decline-modal" id="confirm-decline-modal">
  <div class="modal-header state"></div>
  <div class="modal-body">
    <div>
      <h3 class="mb-2">Are you sure?</h3>
      <p class="text-center">If you do not accept the Terms & Conditions, you will be logged out.</p>
    </div>
    <div class="my-4 text-align-center control-buttons">
      <button type="button" id="btn-confirm" class="btn btn-accept" (click)="logout()">
        LOGOUT
      </button>

      <button type="button"
        id="btn-decline"
        class="btn btn-decline"
        (click)="cancel()">
        CANCEL
      </button>
    </div>

  </div>
</div>
